import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=a18f5e8a&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=a18f5e8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18f5e8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a18f5e8a')) {
      api.createRecord('a18f5e8a', component.options)
    } else {
      api.reload('a18f5e8a', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=a18f5e8a&scoped=true&", function () {
      api.rerender('a18f5e8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2U2N4Db8m2KFn/JS/comp/PopupBox.vue"
export default component.exports